import { render } from "./school.configuration.vue?vue&type=template&id=32e97fe8"
import script from "./school.configuration.vue?vue&type=script&lang=js"
export * from "./school.configuration.vue?vue&type=script&lang=js"

import "./school.configuration.vue?vue&type=style&index=0&id=32e97fe8&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__